<template>
  <el-checkbox-group v-bind="$attrs" v-model="selectValue">
    <slot />
  </el-checkbox-group>
</template>
<script>
export default {
  name: 'RtCheckboxGroup',
  props: {
    value: Array
  },
  data() {
    return {
      selectValue: this.value
    };
  }
};
</script>



// WEBPACK FOOTER //
// rtCheckboxGroup.vue?1b3ed1dc